module.exports = __webpack_public_path__ + "img/Bb1-03-027-002.464a8ae7.jpg";